const vuetifyTheme = {
  primary: "#264355",
  secondary: "#F0F4F7",
  accent: "#0077A0",
};

const menu = [
  {
    path: "/quem-somos",
    name: `Quem Somos`,
  },
  {
    path: "/#servicos",
    name: `Serviços`,
  },
  {
    path: "/#contato",
    name: `Contato`,
  },
];

export { vuetifyTheme, menu };
